import { render, staticRenderFns } from "./01-ColorScalesIntro.vue?vue&type=template&id=01895caa&scoped=true"
import script from "./01-ColorScalesIntro.vue?vue&type=script&lang=ts"
export * from "./01-ColorScalesIntro.vue?vue&type=script&lang=ts"
import style0 from "./01-ColorScalesIntro.vue?vue&type=style&index=0&id=01895caa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01895caa",
  null
  
)

export default component.exports